import { activeLoader, setLicenseExpireFlag } from './view.actions';
import { PvpLibraryService } from '../services/pvp-library.service';
import { CONFIG } from '../helper/config';

export const PvpLibraryActions = {
SET_PVP_CARD:'SET_PVP_CARD',
SET_PVP_LIBRARY_MESSAGE:'SET_PVP_LIBRARY_MESSAGE',
SET_FILTEROBJECT:'SET_FILTEROBJECT',
SET_FILTER_ENTITY_COLUMN_VALUES:'SET_FILTER_ENTITY_COLUMN_VALUES',
UPDATE_FILTER_ENTITY_COLUMN_VALUES:'UPDATE_FILTER_ENTITY_COLUMN_VALUES',
CLEAR_FILTER_ENTITY_COLUMN_VALUES:'CLEAR_FILTER_ENTITY_COLUMN_VALUES'
};

/**
 * update team card state to store
 */

/**
 * Fetches the pvp card data for the given info and auth token.
 * @param {object} info The info object containing the necessary data.
 * @param {string} auth_token The authentication token to use for the request.
 * @param {string} query_id The id of the query to be used for the request.
 * @returns {function(*): void}
 */
export const getPvpCard = (info: any, auth_token: string,query_id) => (
    dispatch: (arg0: any) => void
  ) => {
    dispatch(activeLoader(true));
  
    PvpLibraryService
      .getPvpCard(info, auth_token,query_id)
      .then((result) => {
        dispatch(setPvpCard(result));
        dispatch(activeLoader(false));
      })
      .catch((error: any) => {
        dispatch(handleCatch(error))
      });
};

/**
 * Fetches the distinct column values for the given info, auth token, query id and entity index.
 * @param {object} info The info object containing the necessary data.
 * @param {string} auth_token The authentication token to use for the request.
 * @param {string} query_id The id of the query to be used for the request.
 * @param {number} entity_index The index of the entity for which the distinct column values are to be fetched.
 * @returns {function(*): void}
 */
export const getDistinctColumnValues = (info: any, auth_token: string,query_id:any,entity_index:any) => (
  dispatch: (arg0: any) => void
) => {

  PvpLibraryService
    .getDistinctColumnValues(info, auth_token,query_id)
    .then((result) => {
      dispatch(setEntityColumnValues(result.filter_values,entity_index))
      dispatch(setFilterObj(result.filter_values,entity_index))
    })
    .catch((error: any) => {
      dispatch(handleCatch(error))
    });
};

/**
 * Dispatches an action to update the pvp card state in the store.
 * @param {any} card - The pvp card data to be set in the store.
 * @returns {function} A function that dispatches the SET_PVP_CARD action with the given card data.
 */
export const setPvpCard = (card: any) => (
    dispatch: (arg0: { type: string; payload: { pvp_card: any } }) => void
  ) => {
    dispatch({
      type: PvpLibraryActions.SET_PVP_CARD,
      payload: { pvp_card: card },
    });
};

/**
 * Dispatches an action to set the filter object in the pvp library reducer.
 * @param {object} filter_column The filter column values to set.
 * @param {number} entity_index The index of the entity for which the filter object is to be set.
 * @returns {function} A thunk that dispatches an action to set the filter object.
 */
export const setFilterObj = (filter_column: any,entity_index:any) => (
  dispatch: (arg0: { type: string; payload: {filter_column: any,entity_index:any } }) => void
) => {
  dispatch({
    type: PvpLibraryActions.SET_FILTEROBJECT,
    payload: { filter_column: filter_column, entity_index:entity_index},
  });
};

/**
 * Dispatches an action to set the filter entity column values in the pvp library reducer.
 * @param {object} filter_column The filter column values to set.
 * @param {number} entity_index The index of the entity for which the filter entity column values are to be set.
 * @returns {function} A thunk that dispatches an action to set the filter entity column values.
 */
export const setEntityColumnValues = (filter_column: any,entity_index:any) => (
  dispatch: (arg0: { type: string; payload: {filter_column: any,entity_index:any } }) => void
) => {
  dispatch({
    type: PvpLibraryActions.SET_FILTER_ENTITY_COLUMN_VALUES,
    payload: { filter_column: filter_column, entity_index:entity_index},
  });
};

/**
 * Dispatches an action to update the filter entity column values in the pvp library reducer.
 * @param {object} filter_column The filter column values to update.
 * @param {number} entity_index The index of the entity for which the filter entity column values are to be updated.
 * @returns {function} A thunk that dispatches an action to update the filter entity column values.
 */
export const updateEntityColumnValues = (filter_column: any,entity_index:any) => (
  dispatch: (arg0: { type: string; payload: {filter_column: any,entity_index:any } }) => void
) => {
  dispatch({
    type: PvpLibraryActions.UPDATE_FILTER_ENTITY_COLUMN_VALUES,
    payload: { filter_column: filter_column, entity_index:entity_index},
  });
};

/**
 * Dispatches an action to clear the filter entity column values in the pvp library reducer.
 * @param {any} entity_column The entity column to be cleared.
 * @returns {function} A thunk that dispatches an action to clear the filter entity column values.
 */

export const clearEntityColumnValues = (entity_column: any) => (
  dispatch: (arg0: { type: string; payload: {entity_column: any} }) => void
) => {
  dispatch({
    type: PvpLibraryActions.CLEAR_FILTER_ENTITY_COLUMN_VALUES,
    payload: { entity_column: entity_column},
  });
};

/**
 * Handles errors that occur during the fetching process.
 *
 * @param {any} error - The error to be handled.
 * @param {boolean} [is_loader=true] - Flag to indicate if a loader should be displayed during the request.
 *
 * Dispatches actions to update the store with the error message.
 * Handles any errors that occur during the fetching process.
 */
export const handleCatch = (error, is_loader: boolean = true) => (dispatch: (arg0: any) => void) => {
    if (is_loader)
      dispatch(activeLoader(false));
    if (error.expiry) {
      dispatch(setLicenseExpireFlag(true));
    } else {
      error = typeof error === 'string' ? error : CONFIG.API.ERRORMESSAGE.FAILEDTOFATCH;
      dispatch(setPvpLibraryMessage(error));
    }
}

/**
 * Dispatches an action to update the pvp library message state in the store.
 * @param {string} msg The message to be set in the store.
 * @returns {function} A thunk that dispatches an action to update the pvp library message state.
 */

export const setPvpLibraryMessage = (msg: string) => (dispatch: (arg0: { type: string; payload: { pvp_library_msg: string; }; }) => void) => {
    dispatch({
      type: PvpLibraryActions.SET_PVP_LIBRARY_MESSAGE,
      payload: { pvp_library_msg: msg },
    });
  };

/**
 * Dispatches an action to run a simulation based on the given info and auth token.
 * Calls the runSimulation service to send the request.
 * Dispatches an action to update the pvp card state in the store with the result.
 * Handles any errors that occur during the fetching process.
 * @param {any} info The info object containing the necessary data, including filter columns.
 * @param {string} auth_token The authentication token to use for the request.
 * @returns {function} A thunk that dispatches various actions based on the result of the request.
 */
  export const runSimulation = (info: any, auth_token: string) => (
    dispatch: (arg0: any) => void
  ) => {
    dispatch(activeLoader(true));
    PvpLibraryService
      .runSimulation(info, auth_token)
      .then((result) => {
      dispatch(activeLoader(false))
      
      })
      .catch((error: any) => {
        dispatch(handleCatch(error))
      });
  };

/**
 * Dispatches an action to update the user query based on the given info and auth token.
 * Calls the updateUserQuery service to send the request.
 * Dispatches an action to update the pvp card state in the store with the result.
 * Handles any errors that occur during the fetching process.
 * @param {any} info The info object containing the necessary data.
 * @param {string} auth_token The authentication token to use for the request.
 * @param {any} req_id The id of the query to be updated.
 * @returns {function} A thunk that dispatches various actions based on the result of the request.
 */
  export const updateUserQuery = (info: any, auth_token: string,req_id:any) => (
    dispatch: (arg0: any) => void
  ) => {
    dispatch(activeLoader(true));
  
    PvpLibraryService
      .updateUserQuery(info, auth_token,req_id)
      .then((result) => {
        dispatch(setPvpCard(result));
        dispatch(activeLoader(false));
      })
      .catch((error: any) => {
        dispatch(handleCatch(error))
      });
};